/**
 * Pure business logic for site plan lot data.
 *
 * Covers layer ordering and anchor-path ID resolution.
 * No DOM, no map API, no shared mutable state — all exports are deterministic.
 *
 * @module searchResultsMap/services/sitePlanLots
 */

/**
 * Returns a new array of layers sorted ascending by their order property.
 *
 */
export function sortLayersByOrder(layers) {
  return layers.slice().sort((a, b) => a.order - b.order);
}

export default sortLayersByOrder;